import { useEffect } from "react";
import { trpc } from "@/lib/trpc";
import { funnelOptedOut } from "@/lib/privacySignals";
import { isAutomatedBrowser, isInternalTraffic } from "@/lib/internalTraffic";
import { classifyReferrer, type VisitSource } from "@shared/funnel";

export { funnelOptedOut };

/** Plain yes/no flags (our own device, automated browser) so the server can tally the hit as excluded. Identifies no one. */
export function exclusionFlags(): { internal?: boolean; automation?: boolean } {
  return { ...(isInternalTraffic() ? { internal: true } : {}), ...(isAutomatedBrowser() ? { automation: true } : {}) };
}

/**
 * Counts one visit per browser tab session, in one of five coarse source buckets (direct, search, social, AI,
 * other site). No cookie, no ID and no URL is sent: the server adds 1 to a daily counter. The flag that stops it
 * counting twice lives in sessionStorage and disappears when the tab closes.
 */
export function FunnelBeacon() {
  const hit = trpc.funnel.hit.useMutation();
  useEffect(() => {
    if (funnelOptedOut()) return;
    try {
      if (sessionStorage.getItem("fdp-v")) return;
      sessionStorage.setItem("fdp-v", "1");
    } catch {
      return; // storage blocked: skip rather than count every page load
    }
    const source: VisitSource = classifyReferrer(document.referrer, window.location.hostname);
    hit.mutate({ step: "visit", tag: source, ...exclusionFlags() });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
